require('babel-register')({ ignore: /!(react-draft-editor\/lib)/ })

module.exports = require('./lib')



/** WEBPACK FOOTER **
 ** ./index.js
 **/